/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DeviceRotateLandscapeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Device Rotate Landscape',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M15.158 30H8V6h16v9.21a12.3 12.3 0 0 1 2-.354V2a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v32a2 2 0 0 0 2 2h10.625a12.27 12.27 0 0 1-3.467-6ZM15 2h2a1.04 1.04 0 0 1 1 1 1.04 1.04 0 0 1-1 1h-2a1.023 1.023 0 0 1-1-1 1.024 1.024 0 0 1 1-1Z"
    />
    <path
      d="m32.412 20.332 1.479-1.478a.489.489 0 0 0 .147-.35.5.5 0 0 0-.5-.5h-5.053a.5.5 0 0 0-.447.448V23.5a.5.5 0 0 0 .5.5.489.489 0 0 0 .35-.147l1.5-1.506a6.015 6.015 0 0 1 2.144 5.6 6.074 6.074 0 1 1-8.123-6.615.976.976 0 0 0 .62-.921v-1.255a.76.76 0 0 0-.974-.723 8.919 8.919 0 0 0-6.451 8.552 9.02 9.02 0 0 0 8.645 8.936 8.891 8.891 0 0 0 6.154-15.589Z"
    />
  </svg>`;
};
